import React from 'react';
import { useState, useEffect, useRef } from 'react';

const Agent = 'https://dt7j04u1665qi.cloudfront.net/Agent.webp'
function WeDoBetter() {
    const createObserver = (ref, setIsVisible) => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.2 }
        );
        return observer
    };

    const observeRef = (ref, observer) => {
        if (ref.current) {
            observer.observe(ref.current);
        }
    };

    const [isVisible, setIsVisible] = useState(false);
    const missionRef = useRef(null);

    useEffect(() => {
        const observer = createObserver(missionRef, setIsVisible);

        observeRef(missionRef, observer);

        if (missionRef.current) {
            observer.observe(missionRef.current);
        }

    }, [missionRef]);


    return (
        <>
            <div ref={missionRef} className='py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24 flex flex-col items-center'>
                <div className='w-full flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-12'>
                    <img loading="lazy" alt='We Do Better' className={`w-full lg:w-1/2 rounded-lg shadow-sm object-cover transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} src={Agent} />
                    <div className='w-full lg:w-1/2'>
                        <h1 className={`text-2xl sm:text-3xl md:text-4xl mb-4 font-light tracking-wider transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}>WE DO BETTER</h1>
                        <p className={`text-xs sm:text-sm md:text-base leading-relaxed text-gray-700 transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
                            Haideries can help you navigate the complex legal and administrative aspects of the sales process. We can assist you with paperwork, contracts, and negotiations with potential buyers, which can help you avoid misunderstandings and potential legal issues. Working with us can help ensure that the sales process goes smoothly and efficiently. Overall, listing your property with Haideries Real Estate can help you maximize the value of your property and make the sales process easier and more convenient.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WeDoBetter